"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uid = require("../utils/uid");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = function _default(Origin) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_React$Component) {
    _inheritsLoose(_class, _React$Component);

    function _class(props) {
      var _this;

      _this = _React$Component.call(this, props) || this;
      _this.state = {
        data: []
      };
      _this.groupByData = _this.groupByData.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      _this.groupKey = (0, _uid.getUidStr)();
      return _this;
    }

    var _proto = _class.prototype;

    _proto.componentDidMount = function componentDidMount() {
      this.groupByData();
    };

    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
      if (prevProps.data !== this.props.data) this.groupByData();
    };

    _proto.groupByData = function groupByData() {
      var _this2 = this;

      var _this$props = this.props,
          groupBy = _this$props.groupBy,
          data = _this$props.data;

      if (typeof groupBy !== 'function') {
        this.setState({
          data: data
        });
        return;
      }

      var groupData = {};
      data.forEach(function (d, i) {
        var _ref;

        var g = groupBy(d, i, data);
        if (!groupData[g]) groupData[g || ''] = g ? [(_ref = {}, _ref[_this2.groupKey] = g, _ref)] : [];
        groupData[g].push(d);
      });
      this.setState({
        data: Object.keys(groupData).reduce(function (p, v) {
          return v ? p.concat(groupData[v]) : groupData[v].concat(p);
        }, [])
      });
    };

    _proto.render = function render() {
      var _this$props2 = this.props,
          groupBy = _this$props2.groupBy,
          data = _this$props2.data,
          props = _objectWithoutPropertiesLoose(_this$props2, ["groupBy", "data"]);

      return _react.default.createElement(Origin, _extends({}, props, {
        data: this.state.data,
        groupKey: this.groupKey
      }));
    };

    return _class;
  }(_react.default.Component), _defineProperty(_class, "propTypes", {
    data: _propTypes.default.array,
    groupBy: _propTypes.default.func
  }), _defineProperty(_class, "defaultProps", {
    data: []
  }), _temp;
};

exports.default = _default;